import Module from '../module';
import scroll from '../../libs/scroll/scroll';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

interface OptionsInterface {
	cssId: {
		anim?: {
			homeNewsLinkListItemCls: string;
			homeNewsContentSectionHeaderCls: string;
			homeNewsMoreBtnCls: string;
		}
	},

	slug: string
}

class News extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home News Module');

		this.publicVars = options;

		gsap.registerPlugin(ScrollTrigger);
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeNewsContentSectionHeaderCls || '', 'home_news', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeNewsMoreBtnCls || '', 'home_news', { animCls: 'animate__fadeInUp50P', once: true});

		if(this.publicVars.cssId.anim?.homeNewsLinkListItemCls) {
			const investorsNewsItemsCount = document.querySelectorAll(
				this.publicVars.cssId.anim?.homeNewsLinkListItemCls).length;

			for (let i = 1; i <= investorsNewsItemsCount; i++) {
				scroll.registerAnimatedElement(`${this.publicVars.cssId.anim?.homeNewsLinkListItemCls}${i}`,
					'home_news', { animCls: 'animate__zoomIn50P', once: true });
			}

		}
	}

	bind() {
		this.msg('bind');

	}
}

export default News;